// Module
var code = "<react-component name=\"PaymentProcessingRuns\"></react-component>\n";
// Exports
module.exports = code;